import SyncOverview from "components/layout/Sync/SyncOverview";
import { useParams } from "react-router-dom";
import SyncRouteParams from "types/sync-route-params";

const ProductSyncPage = () => {
  const { source, target, program } = useParams<
    keyof SyncRouteParams
  >() as SyncRouteParams;

  return (
    <SyncOverview
      syncType="Product"
      source={source}
      target={target}
      program={program}
    />
  );
};

export default ProductSyncPage;
